module.exports = __webpack_public_path__ + "img/tool-tip.a6dbd506.svg";